import { useMemo } from 'react';
import Label, { LabelProps } from './Label';
import { useLabelAttachmentsStore } from './labelAttachments.store';
import useLabelDetachment from './useLabelDetachment';

export default function AttachedLabel(props: { id: number; labelDefinition: LabelProps; canEdit: boolean }) {
  const detachLabelMutation = useLabelDetachment();
  const removeLabels = useLabelAttachmentsStore((state) => state.removeLabels);
  const attachTo = useLabelAttachmentsStore((state) => state.attachLabelsTo);

  const onRemove = useMemo(() => {
    if (!props.canEdit) {
      return undefined;
    }

    if (props.id && attachTo) {
      return () => detachLabelMutation(props.id);
    }

    return () => removeLabels([props.labelDefinition.label]);
  }, [props.id, props.canEdit, attachTo, detachLabelMutation, props.labelDefinition.label, removeLabels]);

  return <Label {...props.labelDefinition} onRemove={onRemove} />;
}
